<template>
  <li class="episode" @mouseover="mouseOverHandler" @mouseleave="mouseLeaveHandler" :data-test="`tab-playlist--entry${episode.active ? '--active' : ''}`">
    <div class="cursor-pointer" @click="select({ index, play: true })" aria-hidden="true" data-test="tab-playlist--entry--interaction">
      <span class="inline-block" data-test="tab-playlist--entry--title"> {{ episode.title }} </span>
    </div>

    <!-- <Button class="invisible hidden" @click="select({ index, play: true })">
      {{ $t('A11Y.PLAYLIST_ENTRY', episode) }}
    </Button> -->
  </li>
</template>

<script>
import { compose } from 'ramda';
import { requestPlay, requestPause } from '@/store/actions/play';
import { toHumanTime } from '@/utils/time';

import select from '@/store/selectors';
import store from '@/store';
import { selectEpisode } from '@/store/actions/playlist';

export default {
  components: {
  },

  props: {
    index: {
      type: Number,
      default: null,
    },
    episode: {
      type: Object,
      default: () => ({}),
    },
  },

  data() {
    return {
      ...this.mapState({
        color: select.theme.brandLightest,
        playing: select.driver.playing,
      }),
      hover: false,
    };
  },

  computed: {
    active() {
      return this.chapter.active || this.hover;
    },

    a11y() {
      const remaining = this.chapter.active
        ? this.chapter.end - this.playtime
        : this.chapter.end - this.chapter.start;

      return {
        ...this.chapter,
        remaining: toHumanTime(remaining > 0 ? remaining : 0),
        duration: toHumanTime(this.chapter.end - this.chapter.start),
      };
    },

    style() {
      return this.hover
        ? {
          color: '#fff',
        }
        : {};
    },
  },

  methods: {
    mouseOverHandler() {
      this.hover = true;
    },

    mouseLeaveHandler() {
      this.hover = false;
    },

    play() {
      if (this.playing) {
        store.dispatch(requestPause());
      } else {
        store.dispatch(requestPlay());
      }
    },

    select: compose(
      store.dispatch,
      selectEpisode,
    ),
  },
};
</script>

<style scoped lang="scss">
  @import '~@/assets/scss/media.scss';

  .episode {
    color: #999;
    height: 30px;
    font-size: 12px;
    line-height: 30px;
    overflow: hidden;

    @include only-desktop() {
      font-size: 14px;
    }

  }

  .episode--active {
    color: #fff;
  }
</style>
